export const PriceSimulationStatus = [
    { id: 'All', nameKey: 'priceSimulation.statusAll' },
    { id: 'Unmodified', nameKey: 'priceSimulation.statusUnmodified' },
    { id: 'Draft', nameKey: 'priceSimulation.statusDraft' },
    { id: 'PendingReview', nameKey: 'priceSimulation.statusPendingReview' },
    { id: 'Approved', nameKey: 'priceSimulation.statusApproved' },
    { id: 'Rejected', nameKey: 'priceSimulation.statusRejected' },
];